export const EVENTS_REQUESTED = 'analytics/EVENTS_REQUESTED'
export const EVENTS_SUCCEED = 'analytics/EVENTS_SUCCEED'
export const EVENTS_FAIL = 'analytics/EVENTS_FAIL'
export const UPDATE_EVENT = 'analytics/UPDATE_EVENT'



// WEBPACK FOOTER //
// ./src/redux/analytics/actionTypes.js